import {ReactElement} from "react";
import {ModalHeader, ModalBody} from "@/widgets/ModalParts";
import {Modal} from "@/widgets/Modal";
import {NftOwnership, Token} from "@devour/client";
import {Button} from "@/components/buttons/Button";
import { useSelector } from "react-redux";
import { IStore } from "@/redux/defaultStore";
import { useGetRedeemableNftOwnerships } from "@/hooks/useGetRedeemableNftOwnerships";
import NftOwnershipImage from "@/components/NftOwnershipImage";
import isLootboxUnburnt from "@/utils/isLootboxUnburnt";

interface Props {
    isOpen: boolean;
    onClose: () => void;
    onRedeemClicked: () => void;
    ownership: NftOwnership;
}

function NftOwnershipCardModal(props: Props): ReactElement {
    const fullToken = useSelector((store: IStore) => store.authStore.fullToken);
    const {data: redeemableNftsResponse} = useGetRedeemableNftOwnerships(fullToken as Token);
    const isReedemable = isLootboxUnburnt(props.ownership) && redeemableNftsResponse?.lootboxes?.some((nft) => nft.id === props.ownership.id);
    return (
        <Modal
            isOpen={props.isOpen}
            toggle={props.onClose}
            contentClassName="nft-ownership-card-modal"
        >
            <ModalHeader
                title="Collectible Details"
                toggle={props.onClose}
            />

            <ModalBody className="nft-ownership-card-modal_body">
                <div className="nft-ownership-card-modal_body_thumb-con">
                    {!isLootboxUnburnt(props.ownership) &&
                        <div className="nft-ownership-card-modal_body_thumb-con_loading">
                            <div className="loading-spinner"/>
                        </div>
                    }
                    <NftOwnershipImage
                        ownership={props.ownership}
                        alt="GoFriends Card Thumbnail"
                        className="nft-ownership-card-modal_body_thumb-con_img"
                    />
                </div>

                <div className="nft-ownership-card-modal_body_details">
                    <div className="nft-ownership-card-modal_body_details_tracker-row">
                        <h6 className="nft-ownership-card-modal_body_details_tracker-row_name">
                            {props.ownership.tracker.name}
                        </h6>
                    </div>

                    <h3>
                        #{props.ownership.nftId}
                    </h3>

                    {isReedemable && props.onRedeemClicked &&
                        <Button variant="ghost"
                            onClick={props.onRedeemClicked}
                            className="nft-ownership-card-modal_body_details_btn"
                        >
                            Redeem LootBox
                        </Button>}
                </div>
            </ModalBody>
        </Modal>
    );
}

export default NftOwnershipCardModal;


